import {
  createContext
} from "react";

const MetricsContext = createContext();

export default MetricsContext;